import { hostDefinitionOf, layerBounds } from "./host";
import type { SourceFactory } from "./types";

export const leafletLayerSource: SourceFactory = entry => {
  const definition = hostDefinitionOf(entry);

  if (definition === null || !definition.layer) return null;

  const layer = definition.layer;

  return {
    entry,
    kind: "leaflet",
    layer,
    pane: null,
    bounds: () => definition.fitBounds?.() ?? layerBounds(layer),
    features: null,
    info: null,
    legend: () => entry.legend,
    dispose: () => layer.remove()
  };
};
